import { useFrontendConfig } from '@hooks/useFrontendConfig';

// Render-nothing child mounted inside QueryClientProvider so the frontend-config
// GET fires once at app init, in parallel with session creation, without
// blocking first paint. Consumers read the cached value via usePromoLearnMoreUrl.
export const FrontendConfigBootstrap = (): null => {
  useFrontendConfig();
  return null;
};
